import Prog5 from '../assets/svgs/prog5.svg';
import Prog6 from '../assets/svgs/prog6.svg';
import Prog7 from '../assets/svgs/prog7.svg';
import Prog10 from '../assets/svgs/prog10.svg';
import Prog12 from '../assets/svgs/prog12.svg';
import seamless from '../assets/svgs/seamless.svg';
import INE from '../assets/svgs/INE.svg';
import purple from '../assets/svgs/purple.svg';
import personalized from '../assets/svgs/personalized.svg';

export default [
  {
    img: Prog5,
    name: 'Wings',
    link: 'https://www.Wings.org/programs/wema-university-learning-program-jh2rn?currentTab=CATALOG'
  },
  {
    img: Prog6,
    name: 'LMS',
    link: 'https://elearning.wemabank.com/wema-lms/www/index.php'
  },
  {
    img: Prog7,
    name: 'Plurasight',
    link: 'https://app.pluralsight.com/id?redirectTo=https://app.pluralsight.com/plan-analytics/wema-bank-plc-8cba2'
  },
  {
    img: seamless,
    name: 'SeamlessHR',
    link: 'https://wemabank.seamlesshrms.com/'
  },
  {
    img: INE,
    name: 'INE',
    link: ''
  },
  {
    img: purple,
    name: 'Training Request',
    link: '/training-request'
  },
  {
    img: personalized,
    name: 'Personalized learning ',
    link: '/my-learning'
  },
  {
    img: Prog10,
    name: 'Team Retreat',
    link: 'https://forms.office.com/r/DnBJZACSnv'
  },
  {
    img: Prog12,
    name: 'Purple Space',
    link: 'https://forms.office.com/r/7Z7mRbXE5V'
  }
];
